import TopHeader from "./topHeader";

class PersonasNavigation extends TopHeader {
	constructor(personasWrapper) {
		super(personasWrapper)
	}
}

export default PersonasNavigation;
